export default __webpack_public_path__ + "static/media/1.8c58bed4.png";